import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {Button, Card, Col, Form, Modal, Row} from "react-bootstrap";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
const AIAgent = () => {
    const [agents, setAgents] = useState([]);
    const [models, setModels] = useState([]);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [agentId, setAgentId] = useState(null);
    const [prompts, setPrompts] = useState([]);
    const initialState = {
        agent_name: "",
        agent_code: "",
        agent_type: "GENERAL",
        ai_model: "",
        prompt: "",
        description: "",
        temperature: 0.7,
        max_tokens: 4096,
        allowed_modules: [],
        can_use_documents: true,
        can_use_images: false,
        can_use_voice: false,
        can_access_live_context: true,
        is_default: false,
        is_active: true
    };
    const [formData, setFormData] = useState(initialState);
    const loadAgents = async () => {
        try {
            setLoading(true);
            const res = await axios.get(baseUrl + "ai-agent/");
            setAgents(res.data);
        } catch {
            Swal.fire("Error", "Unable to load AI Agents", "error");
        } finally {
            setLoading(false);
        }
    };
    const loadPrompts = async () => {
        const res = await axios.get(baseUrl + "ai-prompt/");
        setPrompts(res.data);
    };
    const loadModels = async () => {
        try {
            const res = await axios.get(baseUrl + "ai-model/");
            setModels(res.data);
        } catch {
            console.log("Unable to load models");
        }
    };
    useEffect(() => {
        loadAgents();
        loadModels();
        loadPrompts();
    }, []);
    const handleChange = (e) => {
        const {
            name, value, type, checked
        } = e.target;
        setFormData({
            ...formData, [name]: type === "checkbox" ? checked : value
        });
    };
    const handleModules = (e) => {
        const options = e.target.options;
        let selected = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selected.push(options[i].value);
            }
        }
        setFormData({
            ...formData, allowed_modules: selected
        });
    };
    // ======================================
// SAVE
// ======================================
    const saveAgent = async () => {
        try {
            if (editMode) {
                await axios.put(baseUrl + `ai-agent/${agentId}/`, formData);
            } else {
                await axios.post(baseUrl + "ai-agent/", formData);
            }
            Swal.fire("Success", "AI Agent Saved Successfully", "success");
            setShow(false);
            resetForm();
            loadAgents();
        } catch (error) {
            console.log(error);
            Swal.fire("Error", "Unable to Save AI Agent", "error");
        }
    };
// ======================================
// EDIT
// ======================================
    const editAgent = (row) => {
        setEditMode(true);
        setAgentId(row.id);
        setFormData({
            agent_name: row.agent_name,
            agent_code: row.agent_code,
            agent_type: row.agent_type,
            ai_model: row.ai_model,
            description: row.description || "",
            prompt: row.prompt || "",
            temperature: row.temperature,
            max_tokens: row.max_tokens,
            allowed_modules: row.allowed_modules || [],
            can_use_documents: row.can_use_documents,
            can_use_images: row.can_use_images,
            can_use_voice: row.can_use_voice,
            can_access_live_context: row.can_access_live_context,
            is_default: row.is_default,
            is_active: row.is_active,
            addedby: userName,
            ip_address: ipAddress
        });
        setShow(true);
    };
// ======================================
// DELETE
// ======================================
    const deleteAgent = (id) => {
        Swal.fire({
            title: "Delete AI Agent?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(baseUrl + `ai-agent/${id}/`);
                    Swal.fire("Deleted", "AI Agent Deleted", "success");
                    loadAgents();
                } catch {
                    Swal.fire("Error", "Delete Failed", "error");
                }
            }
        });
    };
// ======================================
// RESET
// ======================================
    const resetForm = () => {
        setFormData(initialState);
        setEditMode(false);
        setAgentId(null);
    };
// ======================================
// DATAGRID
// ======================================
    const columns = [{
        field: "id", headerName: "ID", width: 80
    }, {
        field: "agent_name", headerName: "Agent", flex: 1.3
    }, {
        field: "agent_code", headerName: "Code", width: 120
    }, {
        field: "agent_type", headerName: "Type", width: 170
    }, {
        field: "ai_model_name", headerName: "AI Model", flex: 1
    }, {
        field: "provider_name", headerName: "Provider", width: 140
    }, {
        field: "is_default", headerName: "Default", width: 100, renderCell: (params) => params.value ? "Yes" : "No"
    }, {
        field: "is_active",
        headerName: "Status",
        width: 110,
        renderCell: (params) => params.value ? "Active" : "Inactive"
    }, {
        field: "action", headerName: "Action", width: 180, renderCell: (params) => (<>

            <Button

                size="sm"

                variant="warning"

                className="me-2"

                onClick={() => editAgent(params.row)}

            >

                Edit

            </Button>

            <Button

                size="sm"

                variant="danger"

                onClick={() => deleteAgent(params.row.id)}

            >

                Delete

            </Button>

        </>)
    }];
    return (<>

        <Card className="shadow mb-3">

            <Card.Header>

                <Row>

                    <Col>

                        <h5>
                            AI Agent Master
                        </h5>

                    </Col>

                    <Col className="text-end">

                        <Button

                            variant="primary"

                            onClick={() => {
                                resetForm();
                                setShow(true);
                            }}

                        >

                            + Add AI Agent

                        </Button>

                    </Col>

                </Row>

            </Card.Header>

            <Card.Body>

                <div

                    style={{
                        height: 550, width: "100%"
                    }}

                >

                    <ERPDataGrid

                        rows={agents}

                        columns={columns}

                        loading={loading}

                    />

                </div>

            </Card.Body>

        </Card>

        <Modal

            show={show}

            onHide={() => setShow(false)}

            size="xl"

        >

            <Modal.Header closeButton>

                <Modal.Title>

                    {editMode ? "Edit AI Agent" : "Add AI Agent"}

                </Modal.Title>

            </Modal.Header>

            <Modal.Body>

                <Form>

                    <Row>

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>

                                    Agent Name

                                </Form.Label>

                                <Form.Control

                                    name="agent_name"

                                    value={formData.agent_name}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>

                                    Agent Code

                                </Form.Label>

                                <Form.Control

                                    name="agent_code"

                                    value={formData.agent_code}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>

                                    Agent Type

                                </Form.Label>

                                <Form.Select

                                    name="agent_type"

                                    value={formData.agent_type}

                                    onChange={handleChange}

                                >
                                    <option value="GENERAL">
                                        General Assistant
                                    </option>

                                    <option value="CEO">
                                        Hospital Management Assistant
                                    </option>

                                    <option value="PATIENT">
                                        Patient Assistant
                                    </option>

                                    <option value="DOCTOR">
                                        Doctor Assistant
                                    </option>

                                    <option value="APPOINTMENT">
                                        Appointment Assistant
                                    </option>

                                    <option value="OP">
                                        Outpatient (OP) Assistant
                                    </option>

                                    <option value="IP">
                                        Inpatient (IP) Assistant
                                    </option>

                                    <option value="EMERGENCY">
                                        Emergency Assistant
                                    </option>

                                    <option value="PHARMACY">
                                        Pharmacy Assistant
                                    </option>

                                    <option value="LABORATORY">
                                        Laboratory Assistant
                                    </option>

                                    <option value="RADIOLOGY">
                                        Radiology Assistant
                                    </option>

                                    <option value="BILLING">
                                        Billing Assistant
                                    </option>

                                    <option value="INSURANCE">
                                        Insurance Assistant
                                    </option>

                                    <option value="OT">
                                        Operation Theatre Assistant
                                    </option>

                                    <option value="BLOODBANK">
                                        Blood Bank Assistant
                                    </option>

                                    <option value="NURSING">
                                        Nursing Assistant
                                    </option>

                                    <option value="MEDICALRECORD">
                                        Medical Records Assistant
                                    </option>

                                    <option value="ABDM">
                                        ABDM / ABHA Assistant
                                    </option>

                                    <option value="INVENTORY">
                                        Inventory Assistant
                                    </option>

                                    <option value="PURCHASE">
                                        Purchase Assistant
                                    </option>

                                    <option value="FINANCE">
                                        Finance Assistant
                                    </option>

                                    <option value="HR">
                                        HR & Payroll Assistant
                                    </option>

                                    <option value="REPORT">
                                        Reports Assistant
                                    </option>

                                    <option value="ANALYTICS">
                                        Analytics Assistant
                                    </option>
                                </Form.Select>

                            </Form.Group>

                        </Col>

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>

                                    AI Model

                                </Form.Label>

                                <Form.Select

                                    name="ai_model"

                                    value={formData.ai_model}

                                    onChange={handleChange}

                                >

                                    <option value="">
                                        Select AI Model
                                    </option>

                                    {models.map((item) => (<option

                                        key={item.id}

                                        value={item.id}

                                    >

                                        {item.model_name}

                                    </option>))}

                                </Form.Select>

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={12}>

                            <Form.Group>

                                <Form.Label>

                                    Description

                                </Form.Label>

                                <Form.Control

                                    as="textarea"

                                    rows={3}

                                    name="description"

                                    value={formData.description}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={12}>

                            <Form.Group>

                                <Form.Label>

                                    Prompt

                                </Form.Label>

                                <Form.Select

                                    name="prompt"

                                    value={formData.prompt}

                                    onChange={handleChange}

                                >

                                    <option value="">

                                        Select Prompt

                                    </option>

                                    {prompts.map(item => (<option

                                        key={item.id}

                                        value={item.id}

                                    >

                                        {item.prompt_name}

                                    </option>))}

                                </Form.Select>

                            </Form.Group>
                        </Col>

                    </Row>
                    <Row className="mt-3">

                        <Col md={4}>

                            <Form.Group>

                                <Form.Label>

                                    Temperature

                                </Form.Label>

                                <Form.Control

                                    type="number"

                                    step="0.1"

                                    name="temperature"

                                    value={formData.temperature}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                        <Col md={4}>

                            <Form.Group>

                                <Form.Label>

                                    Max Tokens

                                </Form.Label>

                                <Form.Control

                                    type="number"

                                    name="max_tokens"

                                    value={formData.max_tokens}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                        <Col md={4}>

                            <Form.Group>

                                <Form.Label>

                                    Allowed Modules

                                </Form.Label>

                                <Form.Select

                                    multiple

                                    value={formData.allowed_modules}

                                    onChange={handleModules}

                                >
                                    <option value="Dashboard">Dashboard</option>

                                    <option value="Patient">Patient</option>

                                    <option value="Doctor">Doctor</option>

                                    <option value="Appointment">Appointment</option>

                                    <option value="OP">Out Patient (OP)</option>

                                    <option value="IP">In Patient (IP)</option>

                                    <option value="Emergency">Emergency</option>

                                    <option value="Pharmacy">Pharmacy</option>

                                    <option value="Laboratory">Laboratory</option>

                                    <option value="Radiology">Radiology</option>

                                    <option value="Billing">Billing</option>

                                    <option value="Insurance">Insurance</option>

                                    <option value="Operation Theatre">Operation Theatre</option>

                                    <option value="Blood Bank">Blood Bank</option>

                                    <option value="Nursing">Nursing</option>

                                    <option value="Ward Management">Ward Management</option>

                                    <option value="Consultation">Consultation</option>

                                    <option value="Medical Records">Medical Records</option>

                                    <option value="ABDM">ABDM / ABHA</option>

                                    <option value="Inventory">Inventory</option>

                                    <option value="Purchase">Purchase</option>

                                    <option value="Finance">Finance</option>

                                    <option value="HR & Payroll">HR & Payroll</option>

                                    <option value="Reports">Reports</option>

                                    <option value="Analytics">Analytics</option>

                                    <option value="Administration">Administration</option>
                                </Form.Select>

                            </Form.Group>

                        </Col>

                    </Row>

                    <hr/>

                    <Row>

                        <Col md={3}>

                            <Form.Check

                                label="Use Documents"

                                name="can_use_documents"

                                checked={formData.can_use_documents}

                                onChange={handleChange}

                            />

                        </Col>

                        <Col md={3}>

                            <Form.Check

                                label="Use Images"

                                name="can_use_images"

                                checked={formData.can_use_images}

                                onChange={handleChange}

                            />

                        </Col>

                        <Col md={3}>

                            <Form.Check

                                label="Use Voice"

                                name="can_use_voice"

                                checked={formData.can_use_voice}

                                onChange={handleChange}

                            />

                        </Col>

                        <Col md={3}>

                            <Form.Check

                                label="Live ERP Context"

                                name="can_access_live_context"

                                checked={formData.can_access_live_context}

                                onChange={handleChange}

                            />

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={6}>

                            <Form.Check

                                label="Default Agent"

                                name="is_default"

                                checked={formData.is_default}

                                onChange={handleChange}

                            />

                        </Col>

                        <Col md={6}>

                            <Form.Check

                                label="Active"

                                name="is_active"

                                checked={formData.is_active}

                                onChange={handleChange}

                            />

                        </Col>

                    </Row>

                </Form>

            </Modal.Body>

            <Modal.Footer>

                <Button

                    variant="secondary"

                    onClick={() => setShow(false)}

                >

                    Close

                </Button>

                <Button

                    variant="success"

                    onClick={saveAgent}

                >

                    {editMode ? "Update" : "Save"}

                </Button>

            </Modal.Footer>

        </Modal>

    </>);
};
export default AIAgent;